import { render } from "./Top.vue?vue&type=template&id=754612bd&scoped=true"
import script from "./Top.vue?vue&type=script&lang=js"
export * from "./Top.vue?vue&type=script&lang=js"

import "./Top.vue?vue&type=style&index=0&id=754612bd&scoped=true&lang=css"

import exportComponent from "/Users/alexis/Desktop/Software/grupo_albarran_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-754612bd"]])

export default __exports__